import { APIConnector, Settings } from "../base";

const apiConnector = new APIConnector({ timeout: 30000 });

export default class AuthConfig {
	static get base() {
		return Settings.server;
	}

	static get endpointVerifyToken() {
		return `${AuthConfig.base}/login/verifyToken`;
	}

	static get endpointLogin() {
		return `${AuthConfig.base}/login`;
	}

	static get endpointLogout() {
		return `${AuthConfig.base}/logout`;
	}

	static get endpointForgotPassword() {
		return `${AuthConfig.base}/forgotPassword`;
	}

	static get endpointConfirmPassword() {
		return `${AuthConfig.base}/forgotPassword`;
	}

	static get endPointReSendEmailConfirm() {
		return `${AuthConfig.base}/reSendEmail`;
	}
	static get APIConnector() {
		return apiConnector;
	}
}



// WEBPACK FOOTER //
// ./src/provider/auth/AuthConfig.js